import { fetchWrapper } from 'app/_helpers/fetch-wrapper';
import { async } from 'rxjs';
const WMSInbondURL = process.env.REACT_APP_API_WMSINBOUND_URL;
const baseUrl = `${WMSInbondURL}sku`;

export const SkuService = {
    getAll,
    getById,
    create,
    update,
    updateSKUCategory,
    GetSKUforPrint,
    updatecbm,
    updateISDG,
    updatetemperature,
    GetClientSKUList,
    delete: _delete
};

function getAll() {
    return fetchWrapper.get(baseUrl);
}
function updateSKUCategory(params) {
    return fetchWrapper.post(`${baseUrl}/skusubcategory`, params);
    //return fetchWrapper.put(`${baseUrl}`, params);
}
function updatecbm(params) {
    return fetchWrapper.post(`${baseUrl}/update-cbm`, params);
    //return fetchWrapper.put(`${baseUrl}`, params);
}
function updateISDG(params) {
    return fetchWrapper.post(`${baseUrl}/dg-perishable`, params);
    //return fetchWrapper.put(`${baseUrl}`, params);
}
function updatetemperature(params) {
    return fetchWrapper.post(`${baseUrl}/temperature`, params);
    //return fetchWrapper.put(`${baseUrl}`, params);
}

function GetSKUforPrint(id) {
    return fetchWrapper.get(`${baseUrl}/advice-item-id?id=${id}`);
}
function GetClientSKUList(id) {
    return fetchWrapper.get(`${baseUrl}/client-id?id=${id}`);
}
function getById(id) {
    return fetchWrapper.get(`${baseUrl}/${id}`);
}

function create(params) {
    return fetchWrapper.post(baseUrl, params);
}

function update(id, params) {
    return fetchWrapper.put(`${baseUrl}/${id}`, params);
    //return fetchWrapper.put(`${baseUrl}`, params);

}

// prefixed with underscored because delete is a reserved word in javascript
function _delete(id) {
    return fetchWrapper.delete(`${baseUrl}/${id}`);
}